import { render, staticRenderFns } from "./QuestionAndAnswerComponent.vue?vue&type=template&id=58e52add&"
import script from "./QuestionAndAnswerComponent.vue?vue&type=script&lang=ts&"
export * from "./QuestionAndAnswerComponent.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionAndAnswerComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports